module.exports = __webpack_public_path__ + "img/users.c85910aa.svg";